import ScoreTag from "./ScoreTag";

export default ScoreTag;
